import { FLOW_CREDITS_UPGRADE_PURCHASE_MODAL_RECEIVE } from '../constants';

export const receive = (flowCreditUpgradePurchaseModal) => ({
    type: FLOW_CREDITS_UPGRADE_PURCHASE_MODAL_RECEIVE,
    payload: flowCreditUpgradePurchaseModal,
});